import { FormFields } from './FormFields'
import { ChangePasswordButton } from './ChangePasswordButton'
import { SuccessAlert } from './SuccessAlert'
import type React from 'react'

export type ChangePasswordComponents = {
  form?: React.ElementType
  button?: React.ElementType
  successAlert?: React.ElementType
  cancelButton?: React.ElementType
}

export const components: ChangePasswordComponents = {
  form: FormFields,
  button: ChangePasswordButton,
  successAlert: SuccessAlert,
  cancelButton: () => null,
}
